import React from "react";
import { Box, ListItemButton, ListItemIcon } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTheme } from "@mui/material/styles";

const HeaderTab = ({ item, isActive }) => {
  const customization = useSelector((state) => state.customization);
  const theme = useTheme();

  const navigate = useNavigate();
  const Icon = item.icon;
  const itemIcon = item?.icon && <Icon stroke={1.5} size="1.3rem" />;
  return (
    <ListItemButton
      key={item.id}
      selected={isActive}
      sx={{
        borderRadius: `${customization.borderRadius}px`,
        mr: 2,
        backgroundColor: theme.palette.primary.light,
        fontWeight: 500,
        width: 220,
        height: "fit-content",
        padding: "8px 14px",
        justifyContent: "center",
      }}
      onClick={() => item?.url && navigate(item.url)}
    >
      <ListItemIcon sx={{ minWidth: "unset", marginRight: "12px" }}>
        {itemIcon}
      </ListItemIcon>
      <Box>{item.title}</Box>
    </ListItemButton>
  );
};
export default HeaderTab;
